import styled from "styled-components";
import { Color } from "../../styles/Colors";

// Styles specifically for Budget Extractor Modal
export const BudgetModalWrapper = styled.div<{ $open?: boolean }>`
  display: ${(props) => (props.$open ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`;

export const BudgetModalContent = styled.div`
  background-color: ${Color.white};
  border-radius: 8px;
  color: #000;
  max-width: 95vw;
  max-height: 95vh;
  width: auto;
  min-width: 500px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`;

export const BudgetModalHeader = styled.div`
  padding: 20px 20px 10px 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
`;

export const BudgetModalBody = styled.div`
  padding: 0;
  position: relative;
  flex: 1;
  overflow: auto;
  min-height: 0;
`;

export const BudgetModalFooter = styled.div`
  padding: 10px 20px 20px 20px;
  border-top: 1px solid #e0e0e0;
  flex-shrink: 0;
`;

export const BudgetModalCloseButton = styled.button`
  order: 1;
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  box-shadow: none;
  background: unset;
  &:hover {
    color: black;
  }
`;
